import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {INDRABookedTripDetails} from '@ibe.models/booked-trip-details.indra.model.lib';
import * as fromStore from '../_store';
import {Store} from '@ngrx/store';
import {filter, map, take} from 'rxjs/operators';
import * as _ from 'lodash';
import {FormBuilder} from '@angular/forms';
import {INDRAPax} from '@ibe.models/pax.indra.model.lib';
import {ActivatedRoute} from '@angular/router';
import {TAP_MILES_AND_GO_FF_TIER_LEVELS, TAP_MILES_AND_GO_GOLD, TAP_MILES_AND_GO_MILES, TAP_MILES_AND_GO_MILS, TAP_MILES_AND_GO_NAVIGATOR, TAP_MILES_AND_GO_SILVER} from '@ibe.config';
import {PassengerDetailEmergencyContactComponent} from './passenger-detail-emergency-contact/passenger-detail-emergency-contact.component';
import {PassengerDetailPersonalDocumentsComponent} from './passenger-detail-personal-documents/passenger-detail-personal-documents.component';
import {FrequentFlyerComponent} from './frequent-flyer/frequent-flyer.component';
import {PassengerDetailContactsComponent} from './passenger-detail-contacts/passenger-detail-contacts.component';
import {Actions} from '@ngrx/effects';
import {INDRABFMDataStorageService} from '@ibe.services/bfm-data-storage.indra.service';
import {INDRAInfoPax} from '@ibe.models/pnr-data.indra.model.lib';
import {SidebarService} from '@ibe.components/common/sidebar/sidebar.service';
import {FormGroupService} from '@ibe.services/form-group.service';

@Component({
	selector: 'app-passengers-details-indra',
	templateUrl: './passengers-details-indra.component.html',
	styleUrls: ['./passengers-details-indra.component.scss']
})
export class PassengersDetailsIndraComponent implements OnInit, OnDestroy, AfterViewInit {

	public anyFormHasChanges$: Observable<any> = this.store.select(fromStore.getSelectedAnyFormHasChanges).pipe(
		filter(data => !_.isEmpty(data)),
		map(obj => _.reduce(obj, (i, val, k) => val && !(i[k] = val) || i, {}))
	);
	public showSave = false;
	@ViewChild(PassengerDetailEmergencyContactComponent) emergencyContactComp: PassengerDetailEmergencyContactComponent;
	@ViewChild(PassengerDetailPersonalDocumentsComponent) personalDocsComp: PassengerDetailPersonalDocumentsComponent;
	@ViewChild(FrequentFlyerComponent) frequentFlyerComp: FrequentFlyerComponent;
	@ViewChild(PassengerDetailContactsComponent) passengerContactsComp: PassengerDetailContactsComponent;
	public notif: any;
	private passengerInfo$: Observable<INDRAPax> = this.store.select(fromStore.getSelectedPassengersAtIndex);
	private subs$ = new Subscription();
	private _bookedTrip: INDRABookedTripDetails;
	private pnr: string;

	constructor(
		private store: Store<fromStore.State>,
		private fb: FormBuilder,
		private route: ActivatedRoute,
		private actions$: Actions,
		private sidebarService: SidebarService,
		private fbService: FormGroupService,
		private bfmStorage: INDRABFMDataStorageService // TODO[Lucas Santos]: Remove after all be in storage
	) {
	}

	private _saving = false;

	get saving(): boolean {
		return this._saving;
	}

	private _passengerInfo: INDRAPax;

	get passengerInfo(): INDRAPax {
		return this._passengerInfo;
	}

	get notInfant(): boolean {
		return !Object.is('INF', this.passengerInfo.typePax);
	}

	get _hasFrequentFlyer(): boolean {
		return ((this.passengerInfo.tierLevelFF)
			&& TAP_MILES_AND_GO_FF_TIER_LEVELS.includes(this.passengerInfo.tierLevelFF));
	}

	private _loyaltyLogo: string;

	get loyaltyLogo(): string {
		if (_.isNil(this._loyaltyLogo)) {
			switch (this.passengerInfo.tierLevelFF) {
				case TAP_MILES_AND_GO_MILES:
				case TAP_MILES_AND_GO_MILS:
					this._loyaltyLogo = 'loyalty--miles_go';
					break;
				case TAP_MILES_AND_GO_SILVER:
					this._loyaltyLogo = 'loyalty--miles_go_silver';
					break;
				case TAP_MILES_AND_GO_GOLD:
					this._loyaltyLogo = 'loyalty--miles_go_gold';
					break;
				case TAP_MILES_AND_GO_NAVIGATOR:
					this._loyaltyLogo = 'loyalty--navigator';
					break;
				default:
					this._loyaltyLogo = '';
			}
		}
		return this._loyaltyLogo;
	}

	private _logoClasses: string;

	get logoClasses(): string {
		if (_.isNil(this._logoClasses)) {
			switch (this.passengerInfo.tierLevelFF) {
				case TAP_MILES_AND_GO_MILES:
				case TAP_MILES_AND_GO_MILS:
					this._logoClasses = 'logo__miles-go';
					break;
				case TAP_MILES_AND_GO_SILVER:
					this._logoClasses = 'logo__miles-go-silver';
					break;
				case TAP_MILES_AND_GO_GOLD:
					this._logoClasses = 'logo__miles-go-gold';
					break;
				case TAP_MILES_AND_GO_NAVIGATOR:
					this._logoClasses = 'logo__navigator';
					break;
				default:
					this._logoClasses = '';
			}
		}
		return this._logoClasses;
	}

	ngOnInit() {

		this.pnr = this.route.snapshot.paramMap.get('pnr');

		this.subs$.add(
			this.passengerInfo$.subscribe(data => {
				this._passengerInfo = data;
			})
		);

		this.subs$.add(
			this.store.select(
				fromStore.getSelectedNotif
			).subscribe(data => {
				this._saving = false;
				this.notif = data;
			})
		);

		this.subs$.add(
			this.actions$.pipe(
				filter(action => Object.is(fromStore.ActionTypes.SAVE_PASSENGER_SUCCESS, action.type))
			).subscribe(() => {
				this._saving = false;
				// TODO [LUCAS_SANTOS]: UPDATE STATE OF BOOKING DETAILS TO USE STORE AND NOT STORAGE
				this.store.select(
					fromStore.getSelectedBookedTripInfoPax
				).pipe(
					take(1)
				).subscribe((data: INDRAInfoPax) => {
					this.bfmStorage.INDRA_setActiveBookInfoPax(data);
					this.sidebarService.closeSidebar();
				});
			})
		);
	}

	ngOnDestroy() {
		this.subs$.unsubscribe();

		// TODO [Lucas Santos]: Sidebar Component not Emit OnClose when click outside or press ESC Key
		this.onClose();

	}

	ngAfterViewInit() {
		this.subs$.add(
			this.anyFormHasChanges$.pipe(
				filter(data => !_.isEmpty(data))
			).subscribe(() => setTimeout(() => this.showSave = Boolean(true)))
		);

		this.subs$.add(
			this.anyFormHasChanges$.pipe(
				filter(data => _.isEmpty(data))
			).subscribe(() => setTimeout(() => this.showSave = Boolean(false)))
		);
	}

	public saveSidebar() {
		this.anyFormHasChanges$
			.pipe(take(1))
			.subscribe(data => {
				if (this.validateForms(data)) {
					this._saving = true;
					this.store.dispatch(
						new fromStore.SavePassenger({
							...data,
							emergencyContact: this.componentAndFormExists(this.emergencyContactComp) ? this.emergencyContactComp.form.value : {},
							travelDocument: this.componentAndFormExists(this.personalDocsComp) ? this.personalDocsComp.form.value : {},
							frequentFlyer: this.componentAndFormExists(this.frequentFlyerComp) ? this.frequentFlyerComp.form.value : {},
							contact: this.componentAndFormExists(this.passengerContactsComp) ? this.passengerContactsComp.form.value : {}
						}, this.pnr, this.passengerInfo.idPax)
					);
				}
			});
	}

	private componentAndFormExists(component: any): boolean {
		return !_.isNil(component) && !_.isNil(component.form);
	}

	public onClose() {
		this.store.dispatch(new fromStore.CancelEditing());
	}

	public hideNotifications() {
		this.store.dispatch(new fromStore.HideNotificationAction());
	}

	private validateForms(tags: any): boolean {
		let isValid = false;
		Object.keys(tags).forEach(key => {
			switch (key) {
				case 'updateDocument':
				case 'updateDoca':
				case 'updateRedress': {
					this.fbService.markFormAsTouched(this.personalDocsComp.form);
					isValid = this.personalDocsComp.form.valid;
					break;
				}
				case 'updateEmergencyContact': {
					this.fbService.markFormAsTouched(this.emergencyContactComp.form);
					isValid = this.emergencyContactComp.form.valid;
					break;
				}
				case 'updateContact': {
					this.fbService.markFormAsTouched(this.passengerContactsComp.form);
					isValid = this.passengerContactsComp.form.valid;
					break;
				}
				case 'updateFrequentFlyer': {
					this.fbService.markFormAsTouched(this.frequentFlyerComp.form);
					isValid = this.frequentFlyerComp.form.valid;
					break;
				}
				default:
					isValid = false;
			}
		});
		return isValid;
	}

}
